import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const APP_NAME = 'VisionBoard';

/**
 * Hook to set dynamic page title
 * @param titleKey - i18n translation key or static title
 * @param dynamicPart - Optional dynamic part to append (e.g., board name)
 */
export function usePageTitle(titleKey: string, dynamicPart?: string) {
    const { t } = useTranslation();

    useEffect(() => {
        const title = t(titleKey, titleKey); // Fallback to key if translation not found
        const fullTitle = dynamicPart
            ? `${dynamicPart} | ${APP_NAME}`
            : `${title} | ${APP_NAME}`;

        document.title = fullTitle;

        // Cleanup: reset to default when unmounting
        return () => {
            document.title = APP_NAME;
        };
    }, [titleKey, dynamicPart, t]);
}

/**
 * Set page title directly without translation
 */
export function setPageTitle(title: string) {
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
}

export default usePageTitle;
